import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'dspMap',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp'])
    },
    components: {
        mvtMapStatic
    }
};
